import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import './AddKuisioner.css';

const AddKuisioner = ({ isOpen, toggleSidebar, handleLogout }) => {
  const [title, setTitle] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch('https://freddway-v2.credibug.com/api/kategori');
        console.log('Response Status:', response.status); // Periksa status respons
        if (!response.ok) {
          throw new Error('Gagal memuat kategori');
        }
        const data = await response.json();
        console.log('Data kategori diterima:', data); // Log data yang diterima
        setCategories(data);
      } catch (err) {
        console.error('Error memuat kategori:', err.message);
      }
    };
    fetchCategories();
  }, []);     

  useEffect(() => {
    const fetchKuisioner = async () => {
      try {
        const response = await fetch('https://freddway-v2.credibug.com/api/kuisioner');
        const data = await response.json();
        console.log('Data kuisioner dari API:', data); // Debugging
        setQuestions(data);
      } catch (err) {
        console.error('Error:', err.message);
      }
    };
  
    fetchKuisioner();
  }, []);  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!selectedCategory || !title) {
      setError('Kategori dan Pertanyaan harus diisi.');
      return;
    }
  
    try {
      const url = editId
        ? `https://freddway-v2.credibug.com/api/kuisioner/${editId}`
        : 'https://freddway-v2.credibug.com/api/kuisioner';
  
      const method = editId ? 'PUT' : 'POST';
  
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          kategori_id: selectedCategory,
          pertanyaan: title,
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        const categoryTitle = categories.find((cat) => cat.id === selectedCategory)?.title || '';
  
        if (editId) {
          // Update the specific question in the state
          setQuestions((prevQuestions) => {
            return prevQuestions.map((q) =>
              q.id === editId
                ? { ...q, kategori: categoryTitle, pertanyaan: title }
                : q
            );
          });
          setSuccess('Kuisioner berhasil diperbarui!');
        } else {
          // Add the new question to the list with category title
          setQuestions((prevQuestions) => [
            ...prevQuestions,
            { id: data.id, kategori: categoryTitle, pertanyaan: title },
          ]);
          setSuccess('Kuisioner berhasil ditambahkan!');
        }
  
        // Force re-render using a temp key or some state update
        setQuestions((prevQuestions) => [...prevQuestions]);  // Trick React to re-render
  
        setTitle('');
        setSelectedCategory('');
        setEditId(null);
        setError('');
      } else {
        setError(data.message || 'Terjadi kesalahan.');
      }
    } catch (err) {
      setError('Terjadi kesalahan saat memproses kuisioner.');
    }
  };
  
  const handleEdit = (id, kategoriId, pertanyaan) => {
    console.log('Edit ID:', id);
    console.log('Kategori ID:', kategoriId); // Harus berisi kategori_id
    console.log('Pertanyaan:', pertanyaan);
  
    setEditId(id);
    setSelectedCategory(kategoriId); // Atur dropdown ke kategori yang sesuai
    setTitle(pertanyaan);
  };

  const handleDelete = async (id) => {
    const confirmation = window.confirm('Apakah Anda yakin ingin menghapus kuisioner ini?');
    if (confirmation) {
      try {
        const response = await fetch(`https://freddway-v2.credibug.com/api/kuisioner/${id}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          setQuestions(questions.filter((question) => question.id !== id));
          setSuccess('Kuisioner berhasil dihapus');
        } else {
          const errorData = await response.json();
          setError(errorData.message || 'Gagal menghapus kuisioner');
        }
      } catch (err) {
        setError('Terjadi kesalahan saat menghapus kuisioner');
      }
    }
  };

  const renderCategoryTitle = (kategoriId) => {
    const category = categories.find(cat => cat.id === kategoriId);
    return category ? category.title : 'Kategori Tidak Ditemukan';
  };

  return (
    <div className="dashboard">
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
      <div className={`main-content ${isOpen ? 'expanded' : ''}`}>
        <div className="add-kuisioner-container">
          <h2>{editId ? 'Edit Kuisioner' : 'Tambah Kuisioner'}</h2>
          <form onSubmit={handleSubmit}>
            <label>Kategori Kuisioner</label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              required
            >
              <option value="" disabled>Pilih Kategori</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.title}
                </option>
              ))}
            </select>

            <label>Pertanyaan</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />

            <button type="submit">{editId ? 'Update' : 'Tambah'}</button>
          </form>

          {success && <div className="success-message">{success}</div>}
          {error && <div className="error-message">{error}</div>}

          <h3>Daftar Kuisioner</h3>
          <div className="kategori-table">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nama Kategori</th>
                  <th>Pertanyaan</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {questions.map((kuisioner) => (
                  <tr key={kuisioner.id}>
                    <td>{kuisioner.id}</td>
                    <td>{renderCategoryTitle(kuisioner.kategori_id)}</td> {/* Display category title */}
                    <td>{kuisioner.pertanyaan}</td>
                    <td>
                      <button
                        className="edit-button"
                        onClick={() => handleEdit(kuisioner.id, kuisioner.kategori_id, kuisioner.pertanyaan)}
                      >
                        Edit
                      </button>
                      <button
                        className="delete-button"
                        onClick={() => handleDelete(kuisioner.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddKuisioner;
